// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3qDid","range":"MonthRangeSwitch_range__1SBKy","disabled":"MonthRangeSwitch_disabled__3SAzy"};